import useSuspenseBaseFetch from "../../../internal/revamp/fetch/useSuspenseBaseFetch";
/**
 * @see https://sail.stripe.me/data/api/unstable_useSuspenseTextFetch
 */ export default function useSuspenseTextFetch(/**
   * The URL of the resource to be fetched.
   */ url, /**
   * The options to pass to the fetch.
   */ options = {}) {
    return useSuspenseBaseFetch(url, options, 'text');
}

//# sourceMappingURL=useSuspenseTextFetch.js.map